/**
 * Impression de l'étiquette code barre, au format des étiquettes QR (QR-005) : une page par
 * étiquette, à la taille exacte du support (61 x 32 mm, paysage), le code barre étiré sur
 * toute la largeur.
 *
 * L'étiquette est recomposée dans un conteneur à part, enfant direct de <body>, plutôt que
 * de masquer le reste de la fiche au CSS : ces règles dépendaient de la position des lignes
 * dans la page, et cassaient l'impression dès qu'on en ajoutait une au-dessus.
 *
 * Le format de page est injecté le temps de l'impression seulement : une règle @page
 * permanente imposerait 61 x 32 mm à toute impression lancée depuis le back-office.
 *
 * Le composant hôte doit afficher un élément `.barcode-wrapper` contenant, dans l'ordre, le
 * code en clair, éventuellement le libellé, puis le composant <barcode>.
 */
const LABEL_WIDTH = "61mm";
const LABEL_HEIGHT = "32mm";

export default {
  methods: {
    printBarcodeLabel() {
      const source = this.$el.querySelector(".barcode-wrapper");
      if (!source) {
        return;
      }

      const label = document.createElement("div");
      label.className = "barcode-label-print";

      // Code en clair puis libellé : les blocs texte affichés sur la fiche. Le composant
      // <barcode> porte lui aussi `text-center` — son message d'erreur n'est pas un libellé.
      const blocks = [...source.querySelectorAll(":scope > .text-center")].filter(
        (block) => !block.querySelector(".vue-barcode-element")
      );
      blocks.forEach((block, index) => {
        const text = block.textContent.trim();
        if (!text) {
          return;
        }
        const line = document.createElement("div");
        line.className = index === 0 ? "barcode-label-code" : "barcode-label-name";
        line.textContent = text;
        label.appendChild(line);
      });

      // Code barre : le SVG généré par JsBarcode, déformé pour remplir la place restante.
      // L'étirement ne gêne pas la lecture — les barres gardent leurs proportions entre
      // elles, c'est tout ce que lit une douchette.
      const svg = source.querySelector("svg.vue-barcode-element");
      if (svg && svg.style.display !== "none") {
        const bars = document.createElement("div");
        bars.className = "barcode-label-bars";
        const copy = svg.cloneNode(true);
        copy.setAttribute("preserveAspectRatio", "none");
        copy.removeAttribute("width");
        copy.removeAttribute("height");
        bars.appendChild(copy);
        label.appendChild(bars);
      }

      const pageFormat = document.createElement("style");
      pageFormat.textContent = `@page { size: ${LABEL_WIDTH} ${LABEL_HEIGHT}; margin: 0; }`;

      document.head.appendChild(pageFormat);
      document.body.appendChild(label);
      document.documentElement.classList.add("printing-barcode-label");

      const cleanUp = () => {
        window.removeEventListener("afterprint", cleanUp);
        document.documentElement.classList.remove("printing-barcode-label");
        label.remove();
        pageFormat.remove();
      };
      window.addEventListener("afterprint", cleanUp);

      window.print();
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/barcodeLabel.js